/* eslint-disable @typescript-eslint/no-use-before-define */
import omit from 'lodash/omit';
import { defineModule } from 'direct-vuex';
import { moduleActionContext, moduleGetterContext } from '@/plugins/vuex';
import { SourceOptions, adapters } from '@aison/migrator';

import { database, ConnectRequest } from '@/api';

type SourceType = 'database'; // TODO: add aison, etc.
//
export interface SourceState {
  sourceType: SourceType;
  type?: adapters.InputAdapterType;
  adapter: object;
  // Source adapter
  adapterConnected: boolean;
  adapterLoading: boolean;
  adapterError?: object;
}

export interface QueryOptions {
  run: boolean;
  query: string;
}

const initialState = (): SourceState => ({
  sourceType: 'database',
  type: undefined,
  adapter: {},
  // Source adapter
  adapterConnected: false,
  adapterLoading: false,
  adapterError: undefined,
});

const module = defineModule({
  namespaced: true,
  state: initialState,
  getters: {
    currentQuery(...args) {
      const { state } = sourceGetterContext(args);
      return state.queries[state.currentQuery];
    },
    currentQueryIndex: (...args) =>
      sourceGetterContext(args).state.currentQuery,
    adapterConnected: (...args) =>
      sourceGetterContext(args).state.adapterConnected,
    adapterLoading: (...args) => sourceGetterContext(args).state.adapterLoading,
    adapterError: (...args) => sourceGetterContext(args).state.adapterError,
    connectRequest(...args): ConnectRequest {
      const { state } = sourceGetterContext(args);
      return {
        type: state.type,
        adapter: state.adapter,
      };
    },
    config(...args): SourceOptions {
      const { state, rootState } = sourceGetterContext(args);
      return {
        type: state.type,
        adapter: state.adapter,
        read: rootState.read.read,
      };
    },
  },
  mutations: {
    reset(state, options = {}) {
      Object.assign(state, initialState(), options);
    },
    setSourceType(state, value: SourceType) {
      state.sourceType = value;
    },
    setType(state, value: adapters.InputAdapterType) {
      // TODO: reset connected here?
      state.type = value;
    },
    setAdapter(state, adapter: object) {
      // TODO: reset connected here?
      state.adapter = adapter;
    },
    setAdapterLoading(state) {
      state.adapterLoading = true;
      state.adapterConnected = false;
      state.adapterError = undefined;
    },
    setAdapterError(state, error: object) {
      state.adapterConnected = false;
      state.adapterLoading = false;
      state.adapterError = error;
    },
    setAdapterConnected(state, connected: boolean) {
      state.adapterConnected = connected;
      state.adapterLoading = false;
      if (connected) {
        state.adapterError = undefined;
      }
    },
  },
  actions: {
    reset(context, payload: SourceOptions) {
      const { commit } = sourceActionContext(context);
      commit.reset({
        ...omit(payload, ['read']),
      });
    },
    updateAdapter(
      context,
      payload: { type: adapters.InputAdapterType; adapter: object }
    ) {
      const { commit } = sourceActionContext(context);
      commit.setAdapterConnected(false);
      commit.setType(payload.type);
      commit.setAdapter(payload.adapter);
    },
    async connectAdapter(context) {
      const { commit, getters } = sourceActionContext(context);
      commit.setAdapterLoading(null);
      try {
        // await new Promise(resolve => setTimeout(resolve, 5000));
        await database.connect(getters.connectRequest);
        commit.setAdapterConnected(true);
      } catch (error) {
        if (error?.message) {
          commit.setAdapterError(error.message);
        } else {
          commit.setAdapterError(error);
        }
      }
    },
  },
});

const sourceGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, module);
const sourceActionContext = (context: any) =>
  moduleActionContext(context, module);

export default module;
